import React, { useEffect } from 'react';
import { Page, Toast } from 'react-weui';
import { history } from 'umi';

import { getAppId, loginByCode } from '@/services/login';
import { setToken } from '@/utils/token';
import { isWechatAuth, setWechatAuth, clearWechatAuth, getAuthRedirect } from '@/utils/utils';

const redirectToWechatServer = (appid, state = null) => {
  const href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=${state ? state : 'STATE'}#wechat_redirect`;
  window.location.replace(href);
}

const Auth = (props) => {

  const { location: { query: { code, state } } } = props;

  useEffect(() => {
    if (code) {
      const redirectUrl = getAuthRedirect();

      loginByCode({code, shareId: state}).then(res => {
        if (res && res.code === 200) {
          const { token } = res.data;
          setToken(token);
          setTimeout(() => {
            history.replace(redirectUrl.replace(window.location.origin, ""));
          }, 1000);
        }
      }).finally(() => clearWechatAuth());
    } else {
      if (isWechatAuth()) return ;
      getAppId().then(res => {
        if (res && res.code === 200) {
          setWechatAuth();
          redirectToWechatServer(res.data, state);
        }
      })
    }
  }, [code]);

  return (
    <Page className="toast" spacing>
      <Toast icon="loading" show={true}>认证中...</Toast>
    </Page>
  )
}

export default Auth;
